import { grommet } from 'grommet';
import { deepMerge } from 'grommet/utils';

export const theme = deepMerge(grommet, {
  carousel: {
    icons: {
      color: "white"
    }
  },
  global: {
    colors: {
      active: 'light-5',
      placeholder: 'dark-1',
      focus: 'transparent',
    },
    elevation: {
      light: {
        small: '0 0 1px 0 rgba(0, 0, 0, 0.40), 0 1px 2px 0 rgba(0,0,0,0.40)',
        medium: '0 0 2px 0 rgba(0,0,0,0.40), 0 2px 4px 0 rgba(0,0,0,0.40)',
        large: '0 0 1px 0 rgba(0,0,0,0.40), 0 4px 8px 0 rgba(0,0,0,0.40)',
        xlarge: '0 0 1px 0 rgba(0,0,0,0.40), 0 8px 16px 0 rgba(0,0,0,0.40)',
      },
    },
    font: {
      size: '16px',
      height: '20px',
      family: 'Rubik, sans-serif',
    },
    input: {
      weight: 100,
    },
    size: {
      avatar: '36px',
      sidebar: '60px',
    },
  },
  icon: {
    size: {
      medium: '18px',
    },
  },
  paragraph: {
    medium: {
      size: '16px',
      height: '20px',
      maxWidth: '600px',
    },
    large: {
      size: '20px',
      height: '24px',
    },
  },
  accordion: {
    heading: {
      level: 3,
      margin: { vertical: '6px', horizontal: '24px' },
    },
    // hover: {
    //   heading: {
    //     color: 'accent-2',
    //   },
    //   background: 'background-contrast',
    // },
    // icons: undefined,
    border: undefined,
  },
});

export const colors = {
  primary: {
    color: '#004085',
    background: '#cce5ff',
  },
  danger: {
    color: '#721c24',
    background: '#f8d7da',
  },
  warning: {
    color: '#856404',
    background: '#fff3cd',
  },
  info: {
    color: '#0c5460',
    background: '#d1ecf1',
  },
  success: {
    color: '#155724',
    background: '#d4edda',
  },
};
